import { render, staticRenderFns } from "./BalancePageMenuItem.vue?vue&type=template&id=32b4c012&scoped=true&"
import script from "./BalancePageMenuItem.vue?vue&type=script&lang=js&"
export * from "./BalancePageMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./BalancePageMenuItem.vue?vue&type=style&index=0&id=32b4c012&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b4c012",
  null
  
)

export default component.exports